import React from 'react';

const Navigation = ({ currentPage, setCurrentPage, cart, logout }) => {
  return (
    <div className="nav">
      <button 
        className={currentPage === 'browse' ? 'active' : ''}
        onClick={() => setCurrentPage('browse')}
      >
        Browse Products
      </button>
      <button 
        className={currentPage === 'myListings' ? 'active' : ''}
        onClick={() => setCurrentPage('myListings')}
      >
        My Listings
      </button>
      <button 
        className={currentPage === 'addProduct' ? 'active' : ''}
        onClick={() => setCurrentPage('addProduct')}
      >
        Add Product
      </button>
      <button 
        className={currentPage === 'cart' ? 'active' : ''}
        onClick={() => setCurrentPage('cart')}
      >
        Cart ({cart.length})
      </button>
      <button 
        className={currentPage === 'purchases' ? 'active' : ''}
        onClick={() => setCurrentPage('purchases')}
      >
        Purchase History
      </button>
      <button 
        className={currentPage === 'dashboard' ? 'active' : ''}
        onClick={() => setCurrentPage('dashboard')}
      >
        Dashboard
      </button>
      <button onClick={logout}>
        Logout
      </button>
    </div>
  );
};

export default Navigation;